// src/lib/pharmacyFirst/drugs/aht/foundayo.drug.ts
//
// Orforglipron (Foundayo®) film-coated tablets — indication-agnostic product facts.
// Six tablet strengths, one per dose step. Source: AHT Foundayo PGD v2.1, Drug Details.
// Hard capsules (1, 3, 6, 12, 24, 36 mg) are NOT supplied under the PGD and are deliberately not listed.
// QUANTITIES ARE PRE-VERIFIED LOOKUPS. DO NOT CALCULATE.

import type { Drug } from "../../types";

const storageNote =
  "Store in the original package to protect from light. No special temperature storage; no cold chain. Shelf life 2 years.";

export const foundayoDrug: Drug = {
  id: "foundayo",
  name: "Orforglipron (Foundayo®)",
  brandName: "Foundayo",
  drugClass: "GLP-1 receptor agonist (oral, non-peptide)",
  route: "oral",
  defaultFoodTiming: "Take one tablet once daily at any time of day, with or without food.",
  swallowingNote: "Swallow the tablet whole. Do not break, crush or chew it.",
  administrationNote:
    "One tablet per day only; never use more than one tablet to make up a higher dose. Confirm the tablet imprint at every supply: 0.8 mg G1, 2.5 mg G2, 5.5 mg G3, 9 mg G4, 14.5 mg G5, 17.2 mg G6 (colours are shared between strengths).",
  formulations: [
    {
      id: "foundayo-0_8mg-tablet",
      type: "tablet_ir",
      strength: 0.8,
      strengthUnit: "mg",
      storageNote,
      prescribedItemId: "85dc2a4d-c5c7-4316-b8ca-d57fb7b2bca7",
    },
    {
      id: "foundayo-2_5mg-tablet",
      type: "tablet_ir",
      strength: 2.5,
      strengthUnit: "mg",
      storageNote,
      prescribedItemId: "939964e3-ce78-440a-9de4-8dbf15e95cbe",
    },
    {
      id: "foundayo-5_5mg-tablet",
      type: "tablet_ir",
      strength: 5.5,
      strengthUnit: "mg",
      storageNote,
      prescribedItemId: "87c48500-292b-4ea7-ab4a-f968f9272a93",
    },
    {
      id: "foundayo-9mg-tablet",
      type: "tablet_ir",
      strength: 9,
      strengthUnit: "mg",
      storageNote,
      prescribedItemId: "02f5a272-fd8d-4b97-ac56-9281fcac90d9",
    },
    {
      id: "foundayo-14_5mg-tablet",
      type: "tablet_ir",
      strength: 14.5,
      strengthUnit: "mg",
      storageNote,
      prescribedItemId: "00ec6e95-027b-481e-8faf-67c0272230e2",
    },
    {
      id: "foundayo-17_2mg-tablet",
      type: "tablet_ir",
      strength: 17.2,
      strengthUnit: "mg",
      storageNote,
      prescribedItemId: "17691e5c-785e-4951-bd73-7f96d532a679",
    },
  ],
};
